export default __webpack_public_path__ + "static/media/NIAS0450.34I-31700_-23355_0.03154d72.jpg";